module.exports = __webpack_public_path__ + "img/3.dc8c8b99.jpg";